import actions from './actions'; // Assuming the actions are in a separate file
import Immutable from 'seamless-immutable';

const initialState = Immutable({
  isFetching: false,
  errorMessage: '',
  successMessage: '',
  statusCode: 0,
  actionType: '',
  examdashboardDetails: {}, // Placeholder for fetched exam details
});

export default function getDetailsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.GET_DETAILS_REQUEST:
      return Immutable.merge(state, {
        isFetching: true,
      });

    case actions.GET_DETAILS_SUCCESS:
      return Immutable.merge(state, {
        isFetching: false,
        examdashboardDetails: action.examDetails, // Assuming exam details are in payload
      });

    case actions.GET_DETAILS_ERROR:
      return Immutable.merge(state, {
        isFetching: false,
        errorMessage: action.error,
        actionType: 'GET_DETAILS_ERROR',
      });

    case actions.RESET_ACTIONTYPE:
      return Immutable.merge(state, {
        actionType: '',
        errorMessage: '',
        statusCode: 0,
        examDetails: {},
      });

    default:
      return state;
  }
}
